import PeoplePage from './people-page';
import PlanetsPage from './planets-page';
import StarshipsPage from './starships-page';
import LoginPage from './login-page';
import SecretPage from './secret-page';

export {
  PeoplePage,
  PlanetsPage,
  StarshipsPage,
  LoginPage,
  SecretPage
};



// WEBPACK FOOTER //
// ./src/components/pages/index.js